import { CircularProgress } from '@mui/material';
import * as React from 'react';
import { useHistory } from 'react-router';
import styled from 'styled-components';
import { ACTION_TRANSLATION_SUFFIX } from '../../assets/translations/InvestmentStepsDictionary';
import { createInvestment, getProjectInvestments } from '../../globals/ApiHooks'
import colors from '../../globals/colors';
import { TranslatedTerms } from '../../globals/TranslatedTerms';
import { lang } from '../../globals/Translations';
import { NiceNumberWithCurrency } from '../../shared/UIFormatting';
import { IsInvestmentLeagallyBinding } from '../../shared/BusinessIntelligence';
import Investment from '../../shared/Investment';
import Project from '../../shared/Project';
import { getProjectStatus, ProjectStatus } from '../../shared/ProjectStatus';

const InvestmentListWrapper = styled.div`
  display: flex;
  flex-direction:column;
  max-height: 200px;
`

export const InvestmentsList: React.FC<{ project?: Project, includeInvestmentList?: boolean }> = ({ project, includeInvestmentList }) => {
  const [loading, setLoading] = React.useState(false)
  const [investments, setInvestments] = React.useState<Investment[]>()

  const history = useHistory()

  const goToInvestment = (id: string) => history.push('/investment/' + id)

  const beginNewInvestment = async () => {
    if (!project || loading) return;
    setLoading(true)
    const investement = await createInvestment({ projectId: project.projectId })
    const id = investement?.investmentId
    if (id) goToInvestment(id)
    else setLoading(false)
  }

  React.useEffect(() => {
    (async () => {
      if (includeInvestmentList && !investments && project) {
        setLoading(true)
        const result = await getProjectInvestments(project.projectId)
        if (result) setInvestments(result.filter((item) => !IsInvestmentLeagallyBinding(item)))
        setLoading(false)
      }
    })()
  }, [project])

  if (!project || loading) return <button className="disable" style={{ padding: 4 }}><CircularProgress size={30} /></button>

  const status = getProjectStatus(project)
  if (status === ProjectStatus.OPEN_FOR_INVESTMENT && !includeInvestmentList) return <button onClick={beginNewInvestment}>{lang(TranslatedTerms.INVEST_NOW)}</button>
  if (status === ProjectStatus.OPEN_FOR_INVESTMENT && includeInvestmentList && investments) return (
    <InvestmentListWrapper>
      <button onClick={beginNewInvestment}>{lang(TranslatedTerms.INVEST_NOW)}</button>
      {investments.length > 0 && <span className="light" style={{ marginTop: 18, color: colors.light, textAlign: 'center' }}>{lang(TranslatedTerms.INCOMPLETE)}</span>}
      {investments.map((item, key) => <button style={{ marginTop: 6 }} className="light" onClick={() => goToInvestment(item.investmentId)} key={key}> {NiceNumberWithCurrency(item.amount)} - {lang(item.step + ACTION_TRANSLATION_SUFFIX)}</button>)}
    </InvestmentListWrapper>
  )
  return <></>
};

